// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Ernl","row":"Node_row__32EuZ","label":"Node_label__1Rqer","footer":"Node_footer__binPS"};